import md5 from 'md5'
import { log } from './logger'

const hash = message => {
  log( '@coldandgoji/utilities', 'hash', message )

  return md5( message )
}

export {
  hash,
}
